import { useLocation, useNavigate } from 'react-router-dom'
import { useUserContext } from '../components/contexts/UserContext'
import { useEffect } from 'react'

export const useIsAdminOrRedirectToIndex = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { me } = useUserContext()
    useEffect(() => {
        if (me && !me?.isAdmin) navigate('/')
    }, [me, location.pathname])
}
